'use strict';
import ListViewRequest from "@/Common/ListViewRequest.js";
import FormViewRequest from "@/Common/FormViewRequest.js";
import Vue from 'vue';
import Configuration from "./Configuration";
import ElementDragger from "./ElementDragger";
import apiService from '@/Common/ApiService'
import NavigationService from '@/Common/NavigationService'

//import moment from "moment";


let SerialNumber = 1;

let Utility = {

    vue: new Vue(),

    HasServerError: false,

    No: SerialNumber + 1,

    LastModifyTime: new Date(),

    Nav: null,

    SerialNumber: 0,

    Session: {},

    Argument: {},

    Bag: {},

    RecordMoveButtonClick: null,


    //#region Job

    PrepareJob(vueComponent, responseData, finishHandler) {
        let jobId;
        let path;

        path = (location.pathname + location.search);

        if (responseData.ValueSet.JobId != null) {
            Utility.SaveBag("JobId_" + path, responseData.ValueSet.JobId);
        }
    },

    RemoveJob(vueComponent, jobId) {
        let bags;
        let bagName, bagValue;
        let i;


        bags = this.GetAllBags();

        for (i = 0; i < bags.length; i++) {
            bagName = bags[i].Name;
            bagValue = bags[i].Value;

            if (bagName.indexOf("JobId_") == 0 && bagValue == jobId) {
                this.ClearBag(bagName);
                break;
            }
        }
    },
    //#endregion

    CreateListViewRequest: function (vueComponent) {

    },


    LoadListViewResponse: function (vueComponent, responseData, detailCacheData) {
        let data;
        let equal = false;
        let i = 0;



        this.ProcessIso8601Text(vueComponent, responseData);

        data = vueComponent.$data;

        if (responseData.Paging != null) {
            data.Paging = responseData.Paging;
        }

        data.OrderBy = responseData.OrderBy;
        data.CheckedAll = false;

        if (responseData.AttributeSet != null) {
            if (data.AttributeSet == null) {
                data.AttributeSet = {};
            }

            this.SetNotNullAttributes(vueComponent, data.AttributeSet, responseData.AttributeSet);
        }



        if (responseData.Query != null) {

            if (data.Query == null) {
                data.Query = {};
            }


            this.SetNotNullAttributes(vueComponent, data.Query, responseData.Query);

            if (responseData.Query.AttributeSet != null) {
                for (var colunName in data.Query.AttributeSet) {
                    let newAttributObj = {};
                    let attributeObj;

                    attributeObj = data.Query.AttributeSet[colunName];

                    for (var propertyName in attributeObj) {
                        newAttributObj[propertyName] = attributeObj[propertyName]
                    }//end for (var propertyName in attributeObj) {

                    data.Query.AttributeSet[colunName] = newAttributObj;
                }//end for (var colunName in data.Query.AttributeSet) {
            }




        }//end if (responseData.Query != null) {


        if (responseData.ValueSet != null) {

            this.SetNotNullAttributes(vueComponent, data.ValueSet, responseData.ValueSet);

            if (responseData.AttributeSet != null) {
                for (var colunName in data.AttributeSet) {
                    let newAttributObj = {};
                    let attributeObj;

                    attributeObj = data.AttributeSet[colunName];

                    for (var propertyName in attributeObj) {
                        newAttributObj[propertyName] = attributeObj[propertyName]
                    }//end for (var propertyName in attributeObj) {

                    data.AttributeSet[colunName] = newAttributObj;
                }//end for (var colunName in data.Query.AttributeSet) {
            }
        }


        if (responseData.Rows != null) {
            if (data.Rows == null) {
                data.Rows = [];
            }

            data.Rows.length = 0;


            this.PrepareSeqNo(responseData);

            for (i = 0; i < responseData.Rows.length; i++) {
                responseData.Rows[i].Checked = false;
                data.Rows.push(responseData.Rows[i]);
            }


        }



        if (detailCacheData != null) {
            for (i = 0; i < responseData.Rows.length; i++) {
                equal = this.CompareValueSet(detailCacheData.ValueSet, responseData.Rows[i].ValueSet);
                if (equal) {

                    responseData.Rows[i].LastDetail = true;
                }
                else {
                    responseData.Rows[i].LastDetail = false;
                }
            }

            setTimeout(
                function () {
                    this.ClearLastDetailAttribute(vueComponent);
                }.bind(this)
                ,
                1200
            );
        }

    },



    PrepareSeqNo(responseData) {
        let i;
        let baseNo;


        if (responseData.Paging != null) {
            baseNo = responseData.Paging.RecordPerPage * (responseData.Paging.CurrentPageNumber - 1);

            if (responseData.Rows != null) {
                for (i = 0; i < responseData.Rows.length; i++) {
                    if (responseData.Rows[i].ValueSet != null) {
                        responseData.Rows[i].ValueSet.SeqNo = baseNo + i + 1;
                    }
                }
            }
        }
    },

    ClearLastDetailAttribute(vueComponent) {
        let trElements;
        let i;


        trElements = document.querySelectorAll("TR.LastDetail");

        for (i = 0; i < trElements.length; i++) {
            trElements[i].classList.remove("LastDetail");
        }
    },

    CompareValueSet(detailValueSet, listValueSet) {
        let equal = true;
        let propertyName;
        let count = 0;

        for (propertyName in listValueSet) {

            if (detailValueSet.hasOwnProperty(propertyName)) {

                if (Utility.IsDateObject(detailValueSet[propertyName])) {
                    if (this.GetDateText(listValueSet[propertyName]) == detailValueSet[propertyName]) {
                        count++;
                    }
                    else {
                        break;
                    }
                }
                else if (listValueSet[propertyName] == detailValueSet[propertyName]) {
                    count++;
                }
                else {
                    equal = false;
                    break;
                }
            }

            if (count >= 5) {
                break;
            }
        }

        return equal;
    },

    GetQueryStringListBySearchPath(searchPath) {
        let queryStringList = [];
        let tokens, pair;
        let queryStringName, queryStringValue;
        let i;


        tokens = searchPath.split("&");

        for (i = 0; i < tokens.length; ++i) {
            pair = tokens[i].split('=', 2);

            queryStringName = "";
            queryStringValue = "";

            if (pair.length == 1) {
                queryStringName = pair[0]
            }
            else {
                queryStringName = pair[0];
                queryStringValue = pair[1];
                queryStringValue = decodeURIComponent(queryStringValue.replace(/\+/g, " "));
            }

            queryStringList.push(
                {
                    Name: queryStringName,
                    Value: queryStringValue
                }
            );
        }

        return queryStringList;
    },


    GetSingleShotQueryStringList(queryStringList) {
        let singleShotQueryStringList = [];
        let i;

        for (i = 0; i < queryStringList.length; i++) {
            if (queryStringList[i].Name.indexOf("..") == 0) {
                singleShotQueryStringList.push(queryStringList[i]);
            }
        }

        return singleShotQueryStringList;
    },

    GetNonSingleShotQueryStringList(queryStringList) {
        let nonSingleShotQueryStringList = [];
        let i;

        for (i = 0; i < queryStringList.length; i++) {
            if (queryStringList[i].Name.indexOf("..") < 0) {
                nonSingleShotQueryStringList.push(queryStringList[i]);
            }
        }

        return nonSingleShotQueryStringList;
    },

    RenderSearchPathWithoutSingleShot(queryStringList) {
        let newSearchPath = "";
        let singleShotQueryStringList = [];
        let nonSingleShotQueryStringList = [];
        let i;


        singleShotQueryStringList = this.GetSingleShotQueryStringList(queryStringList);

        if (singleShotQueryStringList.length > 0) {
            nonSingleShotQueryStringList = this.GetNonSingleShotQueryStringList(queryStringList);
        }
        else {
            nonSingleShotQueryStringList = queryStringList;
        }

        for (i = 0; i < nonSingleShotQueryStringList.length; i++) {
            newSearchPath = nonSingleShotQueryStringList[i].Name + "=" +
                nonSingleShotQueryStringList[i].Value;

            if (i < nonSingleShotQueryStringList.length - 1) {
                newSearchPath += "&";
            }
        }

        return newSearchPath;
    },

    PrepareListViewRequest: function (vueComponent) {
        let listViewRequest = new ListViewRequest();
        let data;
        let dateText;
        let queryStringList;
        let singleShotQueryStringList;
        let singleShotTargetName;
        let nonSingleShotPath, nonSingleShotSearchPath = "";
        let dateTimeText;
        let dateObject;
        let i;



        data = vueComponent.$data;

        if (data.FirstQuery == null) {
            data.FirstQuery = true;
        }
        else {
            data.FirstQuery = false;
        }


        if (this.Nav == null) {
            this.Nav = new NavigationService(vueComponent);
        }

        if (this.Nav.MatchLastPath()) {
            let pathInfo;

            pathInfo = this.Nav.PeekPath();

            vueComponent.$args = pathInfo.Argument;
        }

        listViewRequest.FirstQuery = data.FirstQuery;


        listViewRequest.SourcePagePath = vueComponent.$route.path;

        Object.assign(listViewRequest.Query, data.Query);


        queryStringList = this.GetQueryStringListBySearchPath(window.location.search.substr(1));

        singleShotQueryStringList = this.GetSingleShotQueryStringList(queryStringList);

        if (singleShotQueryStringList.length > 0) {

            for (i = 0; i < singleShotQueryStringList.length; i++) {

                if (singleShotQueryStringList[i].Name.indexOf("...") == 0) {
                    singleShotTargetName = singleShotQueryStringList[i].Name.replace("...", "");
                    this.SaveBag(singleShotTargetName, singleShotQueryStringList[i].Value);
                }
                else if (singleShotQueryStringList[i].Name.indexOf("..") == 0) {
                    singleShotTargetName = singleShotQueryStringList[i].Name.replace("..", "");

                    listViewRequest.Query.ValueSet[singleShotTargetName] = singleShotQueryStringList[i].Value;
                }
            }

            nonSingleShotSearchPath = this.RenderSearchPathWithoutSingleShot(queryStringList);

            if (nonSingleShotSearchPath != "") {
                nonSingleShotPath = window.location.pathname + "?" + nonSingleShotSearchPath;
            }
            else {
                nonSingleShotPath = window.location.pathname;
            }

            vueComponent.$router.push(nonSingleShotPath);
        }

        for (i in data.Query.ValueSet) {
            if (data.Query.ValueSet[i] == "") {
                data.Query.ValueSet[i] = null;
            }

            if (data.Query.ValueSet[i] != null && data.Query.ValueSet[i] != "") {

                if (typeof (data.Query.ValueSet[i].getMonth) == "function") {
                    dateTimeText = this.GetDateTimeText(data.Query.ValueSet[i]);
                    dateObject = new Date(dateTimeText);


                    //dateText = moment(data.Query.ValueSet[i]).format("YYYY/MM/DD HH:mm:ss");
                    //dateText = dateText.replace(" 00:00:00", "");
                    //data.Query.ValueSet[i] = dateText;

                    data.Query.ValueSet[i] = dateObject;
                }
                else if (typeof (data.Query.ValueSet[i]) == "string") {
                    data.Query.ValueSet[i] = data.Query.ValueSet[i].replace(/^\s+|\s+$/g, '');
                }


                if (
                    data.Query.AttributeSet != null &&
                    typeof (data.Query.ValueSet[i]) == "string" &&
                    (data.Query.AttributeSet[i] != null) &&
                    (data.Query.AttributeSet[i].DataType == "Date" || data.Query.AttributeSet[i].DataType == "DateTime")) {

                    data.Query.ValueSet[i] = new Date(data.Query.ValueSet[i]);
                }
            }
        }

        listViewRequest.OrderBy = data.OrderBy;
        if (data.Paging != null) {
            listViewRequest.Paging.RecordPerPage = data.Paging.RecordPerPage;
            listViewRequest.Paging.CurrentPageNumber = data.Paging.CurrentPageNumber;
            listViewRequest.Paging.TotalCount = data.Paging.TotalCount;
        }

        if (data.Rows != null) {
            for (i = 0; i < data.Rows.length; i++) {
                if (data.Rows[i].Checked == true) {
                    listViewRequest.SelectedRows.push(data.Rows[i]);
                }
            }
        }

        listViewRequest.SelectedRowsFromRequest = listViewRequest.SelectedRows;


        this.ProcessRquestDateObject(vueComponent, listViewRequest);


        return listViewRequest;
    },

    ProcessResponseData: function (responseData) {
        let propertyName;
        let propertyValue;
        let i;

        for (propertyName in responseData) {


            propertyValue = responseData[propertyName];

            if (propertyValue != null) {
                if (propertyName == "AttributeSet" || propertyName == "ValueSet" || propertyName == "SelectedRow") {

                    if (Array.isArray(propertyValue)) {
                        responseData[propertyName] = this.ConvertResponseArrayToDictionary(propertyValue);
                    }
                }
                else if (typeof (propertyValue) == "object") {

                    if (Array.isArray(propertyValue)) {
                        for (i = 0; i < propertyValue.length; i++) {
                            this.ProcessResponseData(propertyValue[i]);
                        }
                    }
                    else {
                        this.ProcessResponseData(propertyValue);
                    }
                }
                else if ((propertyValue + "").indexOf("/Date(") == 0) {
                    responseData[propertyName] = ToJavaScriptDate(propertyValue);
                }
            }
        }
    }
    ,

    ResetSortOrder(vueComponent, orderBy) {
        let tdElements;
        let i;

        vueComponent.LastSortColumnName = null;
        vueComponent.LastSortOrder = null;
        vueComponent.OrderBy = orderBy;

        tdElements = vueComponent.$el.querySelectorAll(".ListTable TD.ASC,.ListTable TD.DESC");

        for (i = 0; i < tdElements.length; i++) {
            tdElements[i].classList.remove("ASC");
            tdElements[i].classList.remove("DESC");
        }
    },

    PrepareListTable(vueComponent) {
        let listTableElements, listTableElement;
        let headerCellElements;
        let firstRowCellElements;
        let lastSortElement;
        let listViewRequest = {};
        let columnName, sortOrder;
        let headerTdElement;
        let i, j;



        vueComponent.$forceUpdate();

        listTableElements = vueComponent.$el.querySelectorAll(".ListTable");

        for (i = 0; i < listTableElements.length; i++) {
            listTableElement = listTableElements[i];



            headerCellElements = listTableElement.querySelectorAll("TR.Header > Td");
            firstRowCellElements = listTableElement.querySelectorAll("TR.Row:nth-child(2) > Td");

            for (j = 0; j < headerCellElements.length; j++) {
                columnName = headerCellElements[j].getAttribute("Name");

                if (columnName == null || columnName == "") {
                    if (firstRowCellElements.length > 0) {
                        columnName = firstRowCellElements[j].getAttribute("Name");
                        if (columnName != null && columnName != "") {
                            headerCellElements[j].setAttribute("Name", columnName);
                        }
                    }
                }

                if (columnName != null && columnName != "") {
                    headerCellElements[j].style.cursor = "pointer";

                    headerCellElements[j].addEventListener(
                        "click",
                        (e) => {

                            headerTdElement = Utility.GetParentElementByTagName(e.target, "TD");

                            lastSortElement = listTableElement.querySelector("TR.Header > Td.ASC,TR.Header > Td.DESC");

                            if (lastSortElement != null) {
                                lastSortElement.classList.remove("ASC");
                                lastSortElement.classList.remove("DESC");
                            }

                            columnName = Utility.GetParentElementByTagName(e.target, "TD").getAttribute("Name");


                            if (vueComponent.LastSortColumnName == columnName) {
                                if (vueComponent.LastSortOrder == null) {
                                    sortOrder = "ASC";
                                }
                                else if (vueComponent.LastSortOrder == "ASC") {
                                    sortOrder = "DESC";
                                }
                                else {
                                    sortOrder = "ASC";
                                }
                            }
                            else {
                                sortOrder = "ASC";
                            }

                            headerTdElement.classList.add(sortOrder);

                            listViewRequest = Utility.PrepareListViewRequest(vueComponent);
                            listViewRequest.Paging.CurrentPageNumber = 1;
                            listViewRequest.OrderBy = `${columnName} ${sortOrder}`;

                            vueComponent.LastSortColumnName = columnName;
                            vueComponent.LastSortOrder = sortOrder;

                            vueComponent.QueryList(listViewRequest);
                        }
                    );
                }
            }
        }
    },


    ToJavaScriptDate(value) {
        var pattern = /Date\(([^)]+)\)/;
        var results = pattern.exec(value);
        var dt = new Date(parseFloat(results[1]));
        return dt;
    },

    //要把所有日期物件 轉為字串
    ProcessRquestDateObject(vueComponent, targetObject) {
        let propertyName;
        let propertyValue = null;


        if (targetObject != null) {
            for (propertyName in targetObject) {


                propertyValue = targetObject[propertyName];

                if (propertyValue != null) {
                    if (this.IsDateObject(propertyValue)) {
                        targetObject[propertyName] = this.GetDateTimeText(propertyValue);
                    }
                    else if (typeof (propertyValue) == "object") {
                        if (Array.isArray(propertyValue)) {
                            //Do Nothing 


                        }
                        else {
                            this.ProcessRquestDateObject(vueComponent, targetObject[propertyName]);
                        }
                    }//end if (typeof (propertyValue) == "string" && this.IsIso8601Text(propertyValue)) {
                }//end if (propertyValue != null) {
            }//end for (propertyName in targetObject) {
        }
    }//end ProcessRquestDateObject(vueComponent, targetObject) {
    ,


    ConvertResponseArrayToDictionary: function (responseArray) {
        var dictionaryObject = {};
        var elementName;
        var elementValue;
        var i;

        for (i = 0; i < responseArray.length; i++) {
            elementName = responseArray[i].Key;
            if (typeof (responseArray[i].Value) != "object") {
                elementValue = responseArray[i].Value;
            }
            else {
                elementValue = responseArray[i].Value;
            }

            if ((elementValue + "").indexOf("/Date(") == 0) {
                elementValue = this.ToJavaScriptDate(elementValue);
            }

            dictionaryObject[elementName] = elementValue;
        }

        return dictionaryObject;
    }
    ,



    ProcessIso8601Text(vueComponent, targetObject) {
        let propertyName;
        let propertyValue = null;


        if (targetObject != null) {
            for (propertyName in targetObject) {

                propertyValue = targetObject[propertyName];

                if (propertyValue != null) {
                    if (typeof (propertyValue) == "string" && this.IsIso8601Text(propertyValue)) {
                        //把 ISO 8601 的字串轉換為日期物件
                        targetObject[propertyName] = this.ConvertIso8601TextToDate(propertyValue);
                    }
                    else if (typeof (propertyValue) == "string" && this.IsMicrosoftDateTimeText(propertyValue)) {
                        //把 ISO 8601 的字串轉換為日期物件

                        this.IsMicrosoftDateTimeText(propertyValue);

                        targetObject[propertyName] = this.ConvertMicrosoftDateTimeTextToDate(propertyValue);
                    }
                    else if (typeof (propertyValue) == "object") {
                        if (Array.isArray(propertyValue)) {
                            //Do Nothing
                            for (let i = 0; i < propertyValue.length; i++) {
                                if (propertyValue[i].ValueSet != null) {
                                    this.ProcessIso8601Text(vueComponent, propertyValue[i].ValueSet);
                                }

                                if (propertyValue[i].Rows != null) {
                                    for (let j = 0; j < propertyValue[i].Rows.length; j++) {
                                        try {
                                            this.ProcessIso8601Text(vueComponent, propertyValue[i].Rows[j].ValueSet);
                                        } catch (ex) {
                                            debugger;

                                        }


                                    }
                                }
                            }
                        }
                        else {
                            this.ProcessIso8601Text(vueComponent, targetObject[propertyName]);
                        }
                    }//end if (typeof (propertyValue) == "string" && this.IsIso8601Text(propertyValue)) {
                }//end if (propertyValue != null) {
            }//end for (propertyName in targetObject) {
        }
    }//end ProcessIso8601Text(vueComponent, targetObject) {
    ,


    SetNotNullAttributes(vueComponent, targetObject, sourceObject, clearNull) {
        let propertyName;


        for (propertyName in sourceObject) {

            if (sourceObject[propertyName] != null) {
                if (typeof (sourceObject[propertyName]) == "object") {

                    if (typeof (sourceObject[propertyName].getMonth) == "function") {
                        //JavaScript 日期 物件

                        //targetObject[propertyName] = sourceObject[propertyName];
                        vueComponent.$set(targetObject, propertyName, sourceObject[propertyName]);
                    }
                    else if (Array.isArray(sourceObject[propertyName])) {

                        //targetObject[propertyName] = sourceObject[propertyName];
                        vueComponent.$set(targetObject, propertyName, sourceObject[propertyName]);

                    }
                    else {
                        if (targetObject[propertyName] == null) {
                            targetObject[propertyName] = {};
                        }

                        this.SetNotNullAttributes(vueComponent, targetObject[propertyName], sourceObject[propertyName], clearNull);
                    }
                }
                else {

                    if (
                        (sourceObject.AttributeSet == null)
                        ||
                        (propertyName != "ValidationMessage" && propertyName != "Success")
                    ) {
                        //targetObject[propertyName] = sourceObject[propertyName];

                        if (targetObject != null) {
                            vueComponent.$set(targetObject, propertyName, sourceObject[propertyName]);
                        }
                    }
                }
            }
            else {
                //do nothing
                if (clearNull) {
                    targetObject[propertyName] = null;
                }
            }
        }//end for (propertyName in sourceObject) {
    }//end SetNotNullAttributes(vueComponent,targetObject, sourceObject) {
    ,

    IsDateObject(dateObj) {
        let isDateObject = false;


        if (dateObj != null && typeof (dateObj) == "object" && typeof (dateObj.getMonth) == "function") {
            isDateObject = true;
        }

        return isDateObject;
    },


    OnCheckAllButtonClick: function (vueComponent) {
        let data;
        let i = 0;


        data = vueComponent.$data;

        if (data.CheckedAll == true) {

            for (i = 0; i < data.Rows.length; i++) {
                data.Rows[i].Checked = true;
            }
        }
        else {
            for (i = 0; i < data.Rows.length; i++) {
                data.Rows[i].Checked = false;
            }
        }
    }//end OnCheckAllButtonClick: function (data) {
    ,

    SaveSession(sessionName, sessionObject) {


        this.Session[sessionName] = sessionObject;
    },


    GetAllSessions() {
        let sessions = [];

        for (var sessionName in this.Session) {
            sessions.push(
                {
                    Name: sessionName,
                    Value: this.Session[sessionName]
                }
            );
        }

        return sessions;
    },

    //#region Cookies
    GetCookie(vueComponent, cookieName) {
        let cookieValue = null;

        cookieValue = vueComponent.$cookies.get(cookieName);

        return cookieValue;
    },

    SaveCookie(vueComponent, cookieName, cookieValue) {

        vueComponent.$cookies.set(cookieName, cookieValue);
    },
    //#endregion


    //#region Session
    GetSession(sessionName) {
        let sessionObject = null;

        sessionObject = this.Session[sessionName];

        return sessionObject;
    },

    ClearSession(sessionName) {
        let sessionObject = null;

        if (sessionName == null || sessionName == "") {
            alert("Utility.ClearSession() , sessionName is null");
            throw "sessionName is null";
        }


        this.Session[sessionName] = null;

        delete this.Session[sessionName];
    },

    ClearAllSessions() {
        let sessionObject = null;

        this.Session = {};
    },

    ClearAllSessionsButKeep(toKeepSessionName) {
        let sessionName;

        for (sessionName in this.Session) {
            if (sessionName != toKeepSessionName) {
                delete this.Session[sessionName];
            }
        }
    },
    //#endregion

    SetArgument(argumentName, argumentValue) {
        this.Argument[argumentName] = argumentValue;
    },


    GetArgument(argumentName) {
        let argumentValue = null;

        argumentValue = this.Argument[argumentName];

        this.Argument = {};

        return argumentValue;
    },


    //#region Bags
    CheckBags() {
        let bagUpdateTimeText;
        let bagUpdateTime;
        let currDateTime;

        bagUpdateTimeText = localStorage.getItem("BagUpdateTime");
        if (bagUpdateTimeText == null) {
            this.ClearAllBags();
        }
        else {
            bagUpdateTime = new Date(bagUpdateTimeText);
            currDateTime = new Date();

            //console.log("(currDateTime - bagUpdateTime)=" + (currDateTime - bagUpdateTime));

            if ((currDateTime - bagUpdateTime) >= (120 * 1000)) {
                console.log("Bags Expired");
                this.ClearAllBags();
            }
        }
    },


    SaveBag(bagName, bagValue) {
        this.CheckBags();


        if (bagValue == null || bagValue == "null" || bagValue == "undefined") {
            alert(`SaveBag(bagName:${bagName},bagValue ) : bagValue can not be null !`);
            throw (`SaveBag(bagName:${bagName},bagValue ) : bagValue can not be null !`);
            return;
        }

        localStorage.setItem("Bag_" + bagName, bagValue);
        this.ModifyBagUpdateTime();
    },


    ModifyBagUpdateTime() {
        let dateTimeText = this.GetDateTimeText();

        localStorage.setItem("BagUpdateTime", dateTimeText);
    },


    GetBagSet() {
        let bagSet = {};
        let bags;
        let bagName, bagValue;
        let i;


        bags = this.GetAllBags();

        bagSet = {};

        for (i = 0; i < bags.length; i++) {
            bagName = bags[i].Name;
            bagValue = bags[i].Value;

            bagSet[bagName] = bagValue;
        }

        return bagSet;
    },


    GetAllBags() {
        let bags = [];
        let keyName;
        let bagName, bagValue;
        let i;


        this.CheckBags();

        for (i = 0; i < localStorage.length; i++) {
            keyName = localStorage.key(i);

            if (keyName.indexOf("Bag_") == 0) {
                bagName = keyName.replace("Bag_", "");


                bagValue = localStorage.getItem(keyName);

                bags.push(
                    {
                        Name: bagName,
                        Value: bagValue
                    }
                );
            }
        }

        return bags;
    },


    GetBag(bagName) {
        let bagValue = null;

        this.CheckBags();

        bagValue = localStorage.getItem("Bag_" + bagName);

        if (bagValue == null && bagName == "DataLanguage") {
            //PROBLEM
            bagValue = "ZH_TW";
        }
        else if (bagValue == null && bagName == "BackendDataLanguage") {
            //PROBLEM
            bagValue = "ZH_TW";
        }

        return bagValue;
    },

    ClearBag(bagName) {

        if (bagName == null || bagName == "") {
            alert("Utility.ClearBag() , bagName is null");
            throw "bagName is null";

        }

        localStorage.removeItem("Bag_" + bagName);
    },


    ClearAllBags() {
        let keyName;
        let i;


        for (i = localStorage.length - 1; i >= 0; i--) {
            keyName = localStorage.key(i);
            if (keyName.indexOf("Bag_") == 0) {
                localStorage.removeItem(keyName);
            }
        }
    },

    ClearAllBagsButKeep(toKeepBagName, toKeepBagName2) {
        let keyName;
        let i;


        for (i = localStorage.length - 1; i >= 0; i--) {
            keyName = localStorage.key(i);
            if (keyName.indexOf("Bag_") == 0) {
                if (keyName != "Bag_" + toKeepBagName && keyName != "Bag_" + toKeepBagName2) {
                    localStorage.removeItem(keyName);
                }
            }
        }
    },
    //#endregion



    //#region LongBags
    CheckLongBags() {
        let bagUpdateTimeText;
        let bagUpdateTime;
        let currDateTime;

        bagUpdateTimeText = localStorage.getItem("LongBagUpdateTime");
        if (bagUpdateTimeText == null) {
            this.ClearAllBags();
        }
        else {
            bagUpdateTime = new Date(bagUpdateTimeText);
            currDateTime = new Date();

            //console.log("(currDateTime - bagUpdateTime)=" + (currDateTime - bagUpdateTime));

            if ((currDateTime - bagUpdateTime) >= (10 * 24 * 60 * 60 * 1000)) { //保留 10 天內的瀏覽紀錄
                console.log("Long Bags Expired");
                this.ClearAllBags();
            }
        }
    },


    SaveLongBag(bagName, bagValue) {
        this.CheckBags();

        localStorage.setItem("LongBag_" + bagName, bagValue);
        this.ModifyBagUpdateTime();
    },


    ModifyLongBagUpdateTime() {
        let dateTimeText = this.GetDateTimeText();

        localStorage.setItem("LongBagUpdateTime", dateTimeText);
    },


    GetLongBagSet() {
        let bagSet = {};
        let bags;
        let bagName, bagValue;
        let i;


        bags = this.GetAllLongBags();

        bagSet = {};

        for (i = 0; i < bags.length; i++) {
            bagName = bags[i].Name;
            bagValue = bags[i].Value;

            bagSet[bagName] = bagValue;
        }

        return bagSet;
    },


    GetAllLongBags() {
        let bags = [];
        let keyName;
        let bagName, bagValue;
        let i;


        this.CheckBags();

        for (i = 0; i < localStorage.length; i++) {
            keyName = localStorage.key(i);

            if (keyName.indexOf("LongBag_") == 0) {
                bagName = keyName.replace("LongBag_", "");


                bagValue = localStorage.getItem(keyName);

                bags.push(
                    {
                        Name: bagName,
                        Value: bagValue
                    }
                );
            }
        }

        return bags;
    },


    GetLongBag(bagName) {
        let bagValue = null;

        this.CheckLongBags();

        bagValue = localStorage.getItem("LongBag_" + bagName);

        return bagValue;
    },

    CleaLongBag(bagName) {
        if (bagName == null || bagName == "") {
            alert("Utility.CleaLongBag() , bagName is null");
            throw "bagName is null";
        }

        localStorage.removeItem("LongBag_" + bagName);
    },


    ClearAllLongBags() {
        let keyName;
        let i;


        for (i = localStorage.length - 1; i >= 0; i--) {
            keyName = localStorage.key(i);
            if (keyName.indexOf("LongBag_") == 0) {
                localStorage.removeItem(keyName);
            }
        }
    },
    //#endregion



    GetValueText(vueComponent, columnName) {
        let valueText = "";
        let valueSet, attributeSet;
        let columnValue;
        let options;
        let i;

        valueSet = vueComponent.ValueSet;
        attributeSet = vueComponent.AttributeSet;

        columnValue = valueSet[columnName];
        valueText = columnValue;

        if (attributeSet != null &&
            attributeSet[columnName] != null &&
            attributeSet[columnName].Options != null
        ) {
            options = attributeSet[columnName].Options;

            for (i = 0; i < options.length; i++) {
                if (options[i].Value == columnValue) {
                    valueText = options[i].Text;
                    break;
                }
            }
        }

        return valueText;
    },


    GetBaseUrl() {
        let baseUrl = "";

        
        if (location.port == 8080 || location.port == 8081) {

            //baseUrl = window["DevelopServerBaseUrl"] + "";
            baseUrl = Configuration.BaseUrl;
        }
        else {
            baseUrl = window.location.protocol + "//" + window.location.host;
        }


        return baseUrl;
    },


    PrepareFormViewRequest: function (vueComponent, extraPropertyName) {
        let formViewRequest = new FormViewRequest();
        let dateText;
        let queryStringList, singleShotQueryStringList;
        let singleShotTargetName;
        let nonSingleShotSearchPath;
        let nonSingleShotPath;
        let data;
        let i;
        var j;


        data = vueComponent.$data;

        if (data.FirstQuery == null) {
            data.FirstQuery = true;
        }
        else {
            data.FirstQuery = false;
        }

        formViewRequest.FirstQuery = data.FirstQuery;

        formViewRequest.SourcePagePath = vueComponent.$route.path;
        Object.assign(formViewRequest.ValueSet, data.ValueSet);

        Object.assign(formViewRequest.ValueSet2, data.ValueSet2);
        Object.assign(formViewRequest.ValueSet3, data.ValueSet3);
        Object.assign(formViewRequest.ValueSet4, data.ValueSet4);

        //if (data != undefined && data != null && data.ValueSet2 != undefined && data.ValueSet2 != null && data.ValueSet2 != "" ) {
        //    Object.assign(formViewRequest.ValueSet2, data.ValueSet2);
        //}

        //if (data != undefined && data != null && data.ValueSet3 != undefined && data.ValueSet3 != null && data.ValueSet3 != "") {
        //    Object.assign(formViewRequest.ValueSet3, data.ValueSet3);
        //}

        //if (data != undefined && data != null && data.ValueSet4 != undefined && data.ValueSet4 != null && data.ValueSet4 != "") {
        //    Object.assign(formViewRequest.ValueSet4, data.ValueSet4);
        //}

        //#region SingShotQueryString
        queryStringList = this.GetQueryStringListBySearchPath(window.location.search.substr(1));
        singleShotQueryStringList = this.GetSingleShotQueryStringList(queryStringList);

        if (singleShotQueryStringList.length > 0) {
            for (i = 0; i < singleShotQueryStringList.length; i++) {
                if (singleShotQueryStringList[i].Name.indexOf("...") == 0) {
                    singleShotTargetName = singleShotQueryStringList[i].Name.replace("...", "");
                    this.SaveBag(singleShotTargetName, singleShotQueryStringList[i].Value);
                }
                else if (singleShotQueryStringList[i].Name.indexOf("..") == 0) {
                    singleShotTargetName = singleShotQueryStringList[i].Name.replace("..", "");

                    formViewRequest.ValueSet[singleShotTargetName] = singleShotQueryStringList[i].Value;
                }
            }

            nonSingleShotSearchPath = this.RenderSearchPathWithoutSingleShot(queryStringList);

            if (nonSingleShotSearchPath != "") {
                nonSingleShotPath = window.location.pathname + "?" + nonSingleShotSearchPath;
            }
            else {
                nonSingleShotPath = window.location.pathname;
            }

            vueComponent.$router.push(nonSingleShotPath);
        }
        //#endregion

        for (i in formViewRequest.ValueSet) {
            if (formViewRequest.ValueSet[i] === "" || formViewRequest.ValueSet[i] == null) {
                formViewRequest.ValueSet[i] = null;
            }
        }

        if (vueComponent.$route.query.Action != null) {
            formViewRequest.Action = vueComponent.$route.query.Action;
        }

        if (vueComponent.$data.Rows != null) {
            formViewRequest.Rows = vueComponent.$data.Rows;
        }

        if (vueComponent.$data.SecondRows != null) {
            formViewRequest.SecondRows = vueComponent.$data.SecondRows;
        }

        if (extraPropertyName != null && vueComponent.$data[extraPropertyName] != null) {
            formViewRequest[extraPropertyName] = vueComponent.$data[extraPropertyName];
        }

        //把所有日期物件轉為字串
        this.ProcessRquestDateObject(vueComponent, formViewRequest);


        return formViewRequest;
    },




    LoadFormViewResponse: function (vueComponent, responseData, clearNull = false) {
        let data;
        let columnName;
        let propertyName;
        let i;


        data = vueComponent.$data;


        if (responseData.Rows != null) {
            for (i = 0; i < responseData.Rows.length; i++) {
                responseData.Rows[i].ValueSet.SeqNo = (i + 1);
            }
        }

        if (responseData.SecondRows != null) {
            vueComponent.SecondRows = responseData.SecondRows;
        }

        if (responseData.ThirdRows != null) {
            vueComponent.ThirdRows = responseData.ThirdRows;
        }

        this.ProcessIso8601Text(vueComponent, responseData);


        this.SetNotNullAttributes(vueComponent, data, responseData, clearNull);

        if (responseData.AttributeSet != null) {
            for (var colunName in data.AttributeSet) {
                let newAttributObj = {};
                let attributeObj;

                attributeObj = data.AttributeSet[colunName];

                for (propertyName in attributeObj) {
                    newAttributObj[propertyName] = attributeObj[propertyName]
                }//end for (var propertyName in attributeObj) {

                data.AttributeSet[colunName] = newAttributObj;
            }//end for (var colunName in data.Query.AttributeSet) {

        }


    },


    //ConvertIso8601TextToDate(dateText) {
    //    let dateObject = null;
    //    let formattedDateText;

    //    formattedDateText = moment(dateText).format("YYYY/MM/DD HH:mm:ss");
    //    formattedDateText = dateText.replace(" 00:00:00", "");

    //    dateObject = new Date(formattedDateText);

    //    return dateObject;
    //},

    ConvertIso8601TextToDate(iso8601DateText) {
        let dateObject;
        let dateTime;
        let dateTimeText;

        dateTime = new Date(iso8601DateText);

        dateTimeText = this.GetDateTimeText(dateTime);

        dateObject = new Date(dateTimeText);

        return dateObject;
    },


    IsIso8601Text(dateText) {
        let isIso8601 = false;
        let iso8601Regex = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$/;


        if (dateText != null) {
            if (typeof (dateText) == "string" && dateText.length > 10 && dateText.indexOf("T") > 0) {
                //isIso8601 = moment(dateText, moment.ISO_8601).isValid();
                isIso8601 = iso8601Regex.test(dateText);
            }
        }

        return isIso8601;
    },

    IsMicrosoftDateTimeText(dateText) {
        let isMicrosftDateTimeText = false;
        let regex = /^\s*Date\((\d+)\)/;

        if (dateText != null && typeof (dateText) == "string") {
            isMicrosftDateTimeText = regex.test(dateText);
        }

        return isMicrosftDateTimeText;
    },


    ConvertMicrosoftDateTimeTextToDate(dateText) {
        let result = null;

        if (dateText != null) {
            result = new Date(parseInt(dateText.substr(6)));
        }

        return result;
    },


    ShowServerError: function (errorMessage) {
        this.HasServerError = true;
        setTimeout(
            () => {
                document.body.insertAdjacentHTML("AfterBegin", "<div style='white-space:prewrap'> " + errorMessage + "</div > ");
            },
            100
        );
    },


    GenerateSerialNumber: function () {
        this.SerialNumber++;

        return this.SerialNumber;
    },

    GenerateUniqueId: function () {
        let uniqueId = "";

        uniqueId =
            Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1) +
            Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1) +
            Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

        return uniqueId;
    },

    OnDataModify: function () {
        this.LastModifyTime = new Date();
    },

    HasSingleShot: function () {
        let hasSingleShot = false;

        if (window.location.href.indexOf("..") > 0) {
            hasSingleShot = true;
        }

        return hasSingleShot;
    },

    NeedReQuery: function (listResponseData) {
        let needReQuery = false;
        let currDateTime = new Date();

        if (listResponseData.CreateTime == null) {
            alert("listResponseData.CreateTime  is  null");
            return;
        }

        if (window.location.href.indexOf("..") > 0) {
            needReQuery = true;
        }
        else if (this.LastModifyTime > listResponseData.CreateTime) {
            needReQuery = true;
        }
        else if ((currDateTime - listResponseData.CreateTime) >= 5000) {
            needReQuery = true;
        }

        return needReQuery;
    }
    ,

    StaffConfirmSend(isLastStaff) {
        let resultPromise;

        if (isLastStaff == null) {
            alert("Utility.StaffConfirmSend() : isLastStaff 不可為空 !");
            throw ("Utility.StaffConfirmSend() : isLastStaff 不可為空 !");
        }

        if (isLastStaff) {
            resultPromise = Utility.Confirm(
                "儲存變更",
                "確認 儲存變更 ?"
            ).then(
                function (result) {
                    if (result) {
                        return Promise.resolve("");
                    }
                }.bind(this)
            );
        }
        else {
            resultPromise = Utility.ConfirmSend()
        }

        return resultPromise;
    },


    ConfirmSend() {
        let resolveHandler = null;
        let resultPromise = new Promise(
            (resolve) => {
                resolveHandler = resolve;
            }
        );

        this.OpenDialog(

            "@/Dialogs/ConfirmSendDialog",
            {}
        ).then(
            function (responseData) {

                if (responseData != null) {
                    return resolveHandler(responseData);
                }
            }
        );

        return resultPromise;
    },

    //Confirm: function (title, description, confirmHandler, argObject) {
    //    let resolveHandler = null;
    //    let resultPromise = new Promise(
    //        (resolve) => {
    //            resolveHandler = resolve;
    //        }
    //    );
    //    let count = 0;
    //    let vueComponent;
    //    let args = {};
    //    let i;


    //    vueComponent = window["TopVue"];

    //    if (argObject != null && argObject.Width != null) {
    //        Utility.SaveSession("DialogArguments", argObject);
    //    }

    //    args = {
    //        Title: title,
    //        Description: description,
    //        ConfirmHandler:
    //            function (responseData) {

    //                if (confirmHandler != null) {
    //                    confirmHandler(responseData);
    //                }

    //                if (resolveHandler != null) {
    //                    //resolveHandler(responseData);
    //                    resolveHandler("");
    //                }
    //            }.bind(this)
    //    };

    //    Object.assign(args, argObject);

    //    vueComponent.$modal.show("ConfirmDialog", args);



    //    return resultPromise;
    //},


    Confirm: function (title, description, confirmHandler, argObject) {
        let resolveHandler = null;
        let resultPromise = new Promise(
            (resolve) => {
                resolveHandler = resolve;
            }
        );


        Utility.OpenDialog("@/Dialogs/NewConfirmDialog",
            {
                Title: title,
                Description: description,
                DialogWidth: "500px"
            }
        ).then(
            function (result) {


                if (result == true) {

                    if (confirmHandler != null) {
                        confirmHandler(result);
                    }

                    return resolveHandler(result);
                }
            }.bind(this)
        );

        return resultPromise;
    },



    ConfirmDelete: function (title, description, confirmHandler) {
        let resolveHandler = null;
        let resultPromise = new Promise(
            (resolve) => {
                resolveHandler = resolve;
            }
        );


        vueComponent = window["TopVue"];

        vueComponent.$modal.show("ConfirmDialog",
            {
                Title: title,
                Description: description,
                ClassName: "Delete",
                ConfirmHandler: function () {
                    if (confirmHandler != null) {
                        confirmHandler();
                    }

                    if (resolveHandler != null) {
                        resolveHandler();
                    }
                }.bind(this)
            }
        );



        return resultPromise;
    },


    //ConfirmDelete: function (vueComponent, confirmHandler) {
    //    let resolveHandler = null;
    //    let promise = new Promise(
    //        (resolve) => {
    //            resolveHandler = resolve;
    //        }
    //    );

    //    let count = 0;
    //    let i;

    //    for (i = 0; i < vueComponent.Rows.length; i++) {
    //        if (vueComponent.Rows[i].Checked == true) {
    //            count++;
    //        }
    //    }

    //    if (count > 0) {
    //        if (confirmHandler != null) {
    //            vueComponent.$modal.show("ConfirmDialog",
    //                {

    //                    Description: "確認刪除所選之 <b>" + count + "</b> 筆資料?!",
    //                    ConfirmHandler: confirmHandler
    //                }
    //            );
    //        }
    //        else {
    //            resolve();
    //        }

    //    }
    //},


    ShowLoadingPicture: function (duration) {
        let vueComponent;

        this.DelayExecute(
            () => {
                if ((new Date() - this.LastHideLoadingPicture) < 50) {
                    return;
                }

                vueComponent = window["TopVue"];

                if (vueComponent == null) {
                    vueComponent = this.vueComponent;
                }

                if (vueComponent.$bus != null) {
                    vueComponent.$bus.$emit("ShowLoading");
                }

                if (duration != null) {
                    setTimeout(
                        () => {
                            Utility.HideLoadingPicture();
                        },
                        duration
                    );
                }
            },
            "ShowLoadingPicture",
            this
        );


    },

    LastHideLoadingPicture: new Date(),

    HideLoadingPicture: function () {
        let vueComponent;
         
        this.LastHideLoadingPicture = new Date();

        vueComponent = window["TopVue"];

        if (vueComponent == null) {
            vueComponent = this.vueComponent;
        }

        if (vueComponent.$bus != null) {

            vueComponent.$bus.$emit("HideLoading");

            setTimeout(
                () => {
                    vueComponent.$bus.$emit("HideLoading");
                },
                400
            );
        }



    }
    ,





    ShowSaveSuccess: function () {
        this.ShowMessage("儲存成功", 1000);
    },

    ShowDeleteSuccess: function () {
        -
            this.ShowMessage("刪除成功", 1000);
    },

    ShowMessage: function (description, duration) {
        let vueComponent;


        vueComponent = window["TopVue"];



        vueComponent.$bus.$emit("ShowMessage",
            {
                Description: description,
                Duration: duration
            }
        );

        return;
        //if (document.querySelector(".vm--container") == null) {
        //    vueComponent.$bus.$emit("ShowMessage",
        //        {
        //            Description: description,
        //            Duration: duration
        //        }
        //    );
        //}
        //else {
        //    let regex = /(<([^>]+)>)/ig;

        //    description = description.replace(regex, "");

        //    alert(description);
        //}

    },

    ShowValidationMessage: function (message, duration) {
        let vueComponent;

        this.HideMessage();

        vueComponent = window["TopVue"];

        if (duration == null) {
            duration = 2000;
        }

        this.ShowMessage(
            "<div class='ValidationMessage' style='color:Red'>" + message + "</div>",
            duration
        );
    },

    HideMessage: function () {
        let vueComponent;

        vueComponent = window["TopVue"];

        vueComponent.$bus.$emit("HideMessage");
    }
    ,

    GetBrowserWidth() {
        let width;

        width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        return width;
    },

    GetBrowserHeight() {
        let height;

        height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        return height;
    },



    GetClientLeft(element) {
        var clientTop = element.offsetLeft;


        while (element.tagName != "BODY") {
            if (element == null) {
                break;
            }
            element = element.offsetParent;
            if (element == null) {
                break;
            }
            clientTop += element.offsetLeft;
        }

        return clientTop;
    },

    GetClientTop(element) {
        var clientTop = element.offsetTop;

        while (element.tagName != "BODY") {
            element = element.offsetParent;
            if (element == null) {
                break;
            }
            clientTop += element.offsetTop;
            if (element == null) {
                break;
            }

            if (window.getComputedStyle(element).getPropertyValue("position") == "absolute") {
                break;
            }
            else if (window.getComputedStyle(element, null).getPropertyValue("position") == "fixed") {

                clientTop += this.GetScrollTop();
                break;
            }
        }

        return clientTop;
    },



    GetScrollTop() {
        var scrollTop = (
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop
        );

        return scrollTop;
    }

    ,

    GetDateText(dateTime) {
        var dateStr;
        var year, month, day;
        var hour, minute, second;

        if (dateTime == null) {
            return "";
        }
        else if (typeof (dateTime) == "string" && dateTime.indexOf("/Date(") == 0) {
            let theValueMilliseconds = parseInt(dateTime.replace(/\D/igm, ""));
             
            dateTime = new Date(theValueMilliseconds);
        }
        else {
            dateTime = new Date(dateTime);
        }

        month = dateTime.getMonth() + 1;
        day = dateTime.getDate();

        if (month.toString().length == 1)
            month = "0" + month;
        if (day.toString().length == 1)
            day = "0" + day;

        hour = dateTime.getHours();
        minute = dateTime.getMinutes();
        second = dateTime.getSeconds();

        if (hour.toString().length == 1)
            hour = "0" + hour;
        if (minute.toString().length == 1)
            minute = "0" + minute;
        if (second.toString().length == 1)
            second = "0" + second;


        if ((year = dateTime.getYear()) < 200)
            year += 1900;


        dateStr = year + "/" + month + "/" + day;

        return dateStr;
    }
    ,

    GetDateTimeText(dateTime) {
        var dateStr;
        var year, month, day;
        var hour, minute, second;

        if (dateTime == null)
            dateTime = new Date();
        else if (typeof (dateTime) == "object")
            dateTime = dateTime;
        else if (typeof (dateTime) == "string" && dateTime.indexOf("/Date(") == 0) {
            let theValueMilliseconds = parseInt(dateTime.replace(/\D/igm, ""));

            dateTime = new Date(theValueMilliseconds);
        }
        else
            dateTime = new Date(dateTime);

        month = dateTime.getMonth() + 1;
        day = dateTime.getDate();

        if (month.toString().length == 1)
            month = "0" + month;
        if (day.toString().length == 1)
            day = "0" + day;

        hour = dateTime.getHours();
        minute = dateTime.getMinutes();
        second = dateTime.getSeconds();

        if (hour.toString().length == 1)
            hour = "0" + hour;
        if (minute.toString().length == 1)
            minute = "0" + minute;
        if (second.toString().length == 1)
            second = "0" + second;


        if ((year = dateTime.getYear()) < 200)
            year += 1900;

        dateStr = year + "/" +
            month + "/" + day + " " +
            hour + ":" + minute + ":" + second;

        return dateStr;
    }
    ,

    GetRocDateText(dateTime) {
        var dateStr;
        var year, month, day;
        var hour, minute, second;

        if (dateTime == null) {
            return "";

        } else {
            dateTime = new Date(dateTime);
        }

        month = dateTime.getMonth() + 1;
        day = dateTime.getDate();

        if (month.toString().length == 1)
            month = "0" + month;
        if (day.toString().length == 1)
            day = "0" + day;

        hour = dateTime.getHours();
        minute = dateTime.getMinutes();
        second = dateTime.getSeconds();

        if (hour.toString().length == 1)
            hour = "0" + hour;
        if (minute.toString().length == 1)
            minute = "0" + minute;
        if (second.toString().length == 1)
            second = "0" + second;


        if ((year = dateTime.getYear()) < 200)
            year += 1900;


        dateStr = (year - 1911) + "." + month + "." + day;

        return dateStr;
    },

    GetWeekDayText(dateTime) {
        let weekday = new Array(7);
        let weekDayText;


        if (dateTime == null)
            dateTime = new Date();
        else if (typeof (dateTime) == "object")
            dateTime = dateTime;
        else
            dateTime = new Date(dateTime);

        //PROBLEM : 應該要用英文 並結合 Word
        weekday[0] = "星期天";
        weekday[1] = "星期一";
        weekday[2] = "星期二";
        weekday[3] = "星期三";
        weekday[4] = "星期四";
        weekday[5] = "星期五";
        weekday[6] = "星期六";

        weekDayText = weekday[dateTime.getDay()];

        return weekDayText;
    },

    GetFileName(filePath) {
        let fileName = (filePath + "").split('/').pop().toLowerCase();

        return fileName;
    },


    GetFileExtension(filePath) {
        // let fileExtension = filePath.split('.').length > 1 ? filePath.split('.').pop().toLowerCase() : "";
        let fileExtension = filePath.slice((filePath.lastIndexOf(".") - 1 >>> 0) + 2).toLowerCase();

        return fileExtension;
    },

    IsImageFile(filePath) {
        var allowedExtension = ['jpeg', 'jpg', 'png', 'gif', 'bmp'];
        // var fileExtension = filePath.split('.').pop().toLowerCase();
        var fileExtension = this.GetFileExtension(filePath);
        var isImage = false;

        for (var index in allowedExtension) {

            if (fileExtension === allowedExtension[index]) {
                isImage = true;
                break;
            }
        }

        return isImage;
    },


    IsIE() {
        let isIE = false;
        let isIE10 = false;
        let isIE11 = false;

        isIE10 = (navigator.appName == "Microsoft Internet Explorer") ? true : false;
        if (isIE10) {
            isIE = true;
        }
        else {
            isIE11 = !!window.MSStream;

            if (isIE11) {
                isIE = true;
            }
        }

        return isIE;
    },



    GetBranchNo() {
        let branchNo;
        let systemUser;

        branchNo = localStorage.getItem("BranchNo");

        systemUser = JSON.parse(localStorage.getItem("SystemUser"));

        if (systemUser == null) {
            branchNo = this.vue.$cookies.get("BranchNo");
        }
        else {
            branchNo = systemUser.BranchNo;
        }

        if (branchNo == null) {
            branchNo = 1;
        }

        if (typeof (branchNo) == "string") {
            branchNo = parseInt(branchNo);
        }


        return branchNo;
    }

    ,

    GetSystemUserNo() {
        let systemUserNo;
        let systemUser = null;


        systemUser = JSON.parse(localStorage.getItem("SystemUser"));

        if (systemUser != null) {
            systemUserNo = systemUser.SystemUserNo;
        }


        return systemUserNo;
    },

    GetCurrencyFormatText: function (amount, decimalCount = 0, decimal = ".", thousands = ",") {
        try {

            if (amount == "" || isNaN(amount)) {
                return amount;
            }

            decimalCount = Math.abs(decimalCount);
            decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

            const negativeSign = amount < 0 ? "-" : "";

            let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
            let j = (i.length > 3) ? i.length % 3 : 0;

            return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
            console.log(e);
        }
    }
    ,

    GotoLink(vueComponent, url) {
        let anchorElement;
        let anchorName;
        let clientTop;
        let tokens;


        tokens = url.split("#");

        if (tokens.length >= 2) {
            anchorName = tokens[1];
            vueComponent.$router.push(url);

            setTimeout(
                function () {
                    anchorElement = document.querySelector(`A[name='${anchorName}']`);

                    if (anchorElement != null) {
                        this.ScrollToAnchor(anchorName);
                    }
                    else {
                        setTimeout(
                            function () {
                                this.ScrollToAnchor(anchorName);
                            }.bind(this),
                            1000
                        );
                    }

                }.bind(this),
                200
            );
        }
        else {
            vueComponent.$router.push(url);
        }

    },

    
    GoTo(path, argument) {


        if (this.Nav == null) {
            this.Nav = new NavigationService(window["TopVue"]);
        }

        this.Nav.GoTo(path, argument);
    },

    Goto(path, argument) {
        let currPath;

        if (this.Nav == null) {
            this.Nav = new NavigationService(window["TopVue"]);
        }


        currPath = window.location.pathname + window.location.search;

        if (!this.Nav.MatchLastPath()) {
            this.Nav.PushPath(
                {
                    Path: currPath
                }
            );
        }

        this.Nav.GoTo(path, argument);
    },

    GoToWithoutPushPath(path) {
        this.vueComponent.$router.push(path);
    },


    GoBack() {
        this.Nav.GoBack();
    },


    ScrollToAnchor(anchorName) {
        let anchorElement;
        let clientTop;

        anchorElement = document.querySelector(`A[name='${anchorName}']`);


        if (anchorElement != null) {
            clientTop = this.GetClientTop(anchorElement);
            clientTop -= 30;
            window.scrollTo(0, clientTop);
        }
    },


    IsInteger(val) {
        let isInteger = false;

        if (val == "" || isNaN(val)) {
            return isInteger = false;
        }
        else {
            isInteger = true;
        }

        return isInteger;
    }
    ,

    GetQueryString(name, url) {
        let regex;
        let results;


        if (!url) {
            url = window.location.href;
        }

        name = name.replace(/[\[\]]/g, '\\$&');
        regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');

        results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';

        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },


    async GetFormData(formDataKey) {
        let formDataResponse;
        let formData;

        formDataResponse = await apiService.Post(
                                "/Controllers/ServerWebResponseController.aspx/GetResponseFormDataJson",
                                {
                                    Key: formDataKey
                                }
                            );

        formData = JSON.parse(formDataResponse.FormDataJson);

        window["ResponseFormData"] = formData;
        Utility.SaveSession("ResponseFormData", formData);

        return formData;
    },


    GetCenterWindowLayout(width, height) {
        let layout = new WindowLayout();
        let browserWidth, browserHeight;

        browserWidth = this.GetBrowserWidth();
        browserHeight = this.GetBrowserHeight();

        //    layout.X = ((screen.width / 2) - (width / 2));
        //    layout.Y = ((screen.height / 2) - (height / 2));

        layout.X = ((browserWidth / 2) - (width / 2));
        layout.Y = ((browserHeight / 2) + this.GetScrollTop() - (height / 2));

        layout.Width = width;
        layout.Height = height;

        return layout;
    }

    ,

    IsMobile() {
        let isMobile = (/iphone|ipod|android|blackberry|fennec/).test(navigator.userAgent.toLowerCase());

        return isMobile;
    },




    GetParentElementBySelector(element, containerSelector) {
        let parentElement = null;

        parentElement = element;

        while (true) {
            if (parentElement.matches(containerSelector)) {
                break;
            }
            else {
                parentElement = parentElement.parentElement;
                if (parentElement.tagName == "BODY") {

                    throw `Can not fine containerElement with selector '${containerSelector}' `;
                }
            }
        }//end while (true) {

        return parentElement;
    },

    GetParentElementByTagName(element, tagName) {
        let parentElement = null;

        parentElement = element;

        while (parentElement != null) {
            if (parentElement.tagName == tagName) {
                break;
            }
            parentElement = parentElement.parentElement;
        }

        return parentElement;
    },

    GetParentElementByClassName(element, className) {
        let parentElement = null;

        parentElement = element;

        while (parentElement != null) {
            if (parentElement.classList.contains(className)) {
                break;
            }
            parentElement = parentElement.parentElement;
        }

        return parentElement;
    }

    ,

    PrepareScriptSrc(scriptSrc) {
        let element;
        let i;

        for (i = 0; i < document.head.children.length; i++) {
            element = document.head.children[i];
            if (element.tagName == "SCRIPT") {
                if (element.getAttribute("src") == scriptSrc) {
                    return;
                }
            }
        }

        element = document.createElement("script");
        element.setAttribute("src", scriptSrc);
        document.head.appendChild(element)
    },



    SwitchArrayElement(array, index1, index2) {
        let smallIndex, bigIndex;
        let smallItem, bigItem;


        if (index1 > index2) {
            smallIndex = index2;
            bigIndex = index1;
        }
        else {
            smallIndex = index1;
            bigIndex = index2;
        }

        smallItem = array[smallIndex];
        bigItem = array[bigIndex];

        array[smallIndex] = bigItem;
        array[bigIndex] = smallItem;

        this.TouchArray(array);
    },


    RemoveArrayElement(array, elm) {
        let index = array.indexOf(elm);

        if (index > -1) {
            array.splice(index, 1);
        }
    },


    SetPrefixTdColSpan(prfixTdElement) {
        let tableElement;
        let rowElement, tdElement;
        let colSpan = 0;
        let display;
        let i;


        tableElement = this.GetParentElementByTagName(prfixTdElement, "TABLE");
        if (tableElement != null) {
            rowElement = tableElement.rows[0];

            for (i = 0; i < rowElement.cells.length; i++) {
                tdElement = rowElement.cells[i];

                display = window.getComputedStyle(tdElement, null).getPropertyValue("display");
                if (display != "none") {
                    colSpan++;
                }
            }

            colSpan -= 1;

            prfixTdElement.colSpan = colSpan;
        }
    },

    Print() {
        document.querySelector(".MenuContainer").style.display = "none";

        window.print();

        setTimeout(
            () => {
                document.querySelector(".MenuContainer").style.display = "";
            },
            1000
        );
    },


    AddToShoppingCart(productNo, variationNo) {
        let formViewRequest = {
            ValueSet: {
            }
        };

        formViewRequest.ValueSet.ProductNo = productNo;
        formViewRequest.ValueSet.ProductVariationNo = variationNo;

        this.ShowLoadingPicture(window["TopVue"]);

        apiService.Post("/api/ShoppingCart/AddToShoppingCart", formViewRequest).then(
            (responseData) => {
                this.HideLoadingPicture(window["TopVue"]);

                if (responseData.Success == true) {
                    this.ShowMessage("已加入購物車");
                }
                else {
                    this.ShowValidationMessage(responseData.ValidationMessage);
                }
            }
        ).catch(
            (error) => {
                this.HideLoadingPicture(window["TopVue"]);

                alert(error);
            }
        );
    },


    AddToFavorites(productNo) {
        let formViewRequest = {
            ValueSet: {
            }
        };

        formViewRequest.ValueSet.ProductNo = productNo;

        this.HideMessage(window["TopVue"]);

        if (this.GetBag("CustomerNo") != null) {
            this.ShowLoadingPicture(window["TopVue"]);


            formViewRequest.ValueSet.ProductNo = productNo;
            formViewRequest.ValueSet.CustomerNo = parseInt(this.GetBag("CustomerNo") + "");

            apiService.Post("/api/CustomerArea/AddToFavorites", formViewRequest).then(
                (responseData) => {
                    this.HideLoadingPicture(window["TopVue"]);

                    if (responseData.Success == true) {
                        this.ShowMessage(window["TopVue"], "已加入收藏 !", 500);
                    }
                    else {
                        this.ShowValidationMessage(responseData.ValidationMessage);
                    }
                }
            ).catch(
                (error) => {
                    this.HideLoadingPicture(window["TopVue"]);

                    alert(error);
                }
            );
        }
        else {
            let favorites = "";
            let tokens;

            if ((favorites = this.GetBag("Favorites")) == null) {
                this.SaveBag("Favorites", productNo + "");
            }
            else {
                tokens = favorites.split(",");

                if (tokens.indexOf(productNo + "") <= 0) {
                    favorites += "," + productNo;
                    this.SaveBag("Favorites", favorites);
                }
            }
        }
    },


    RemoveFromFavorites(productNo) {
        let formViewRequest = {
            ValueSet: {
            }
        };
        let index;
        let newTokens = [];
        let i;

        formViewRequest.ValueSet.ProductNo = productNo;


        this.HideMessage();

        if (this.GetBag("CustomerNo") != null) {
            this.ShowLoadingPicture(this.TopVueComponent);

            formViewRequest.ValueSet.ProductNo = productNo;
            formViewRequest.ValueSet.CustomerNo = parseInt(this.GetBag("CustomerNo") + "");

            return apiService.Post("/api/CustomerArea/RemoveFromFavorites", formViewRequest).then(
                (responseData) => {
                    this.HideLoadingPicture(this.TopVueComponent);

                    if (responseData.Success == true) {
                        this.ShowMessage(this.TopVueComponent, "已移除收藏 !", 500);
                    }
                    else {
                        this.ShowValidationMessage(responseData.ValidationMessage);
                    }

                    return new Promise(
                        (resolve) => {
                            resolve();
                        }
                    );
                }
            ).catch(
                (error) => {
                    this.HideLoadingPicture(this.TopVueComponent);

                    alert(error);
                }
            );
        }
        else {
            let favorites = "";
            let tokens;

            if ((favorites = this.GetBag("Favorites")) == null) {
                //Do Nothing
                //this.SaveBag("Favorites", productNo + "");
            }
            else {
                tokens = favorites.split(",");

                for (i = 0; i < tokens.length; i++) {
                    if (tokens[i] != (productNo + "")) {
                        newTokens.push(tokens[i]);
                    }
                }

                favorites = newTokens.join(",");
                this.SaveBag("Favorites", favorites);
            }
        }
    },



    ResetImagesForRwd() {
        let imgElements;

        imgElements = document.querySelectorAll(".MainContainer IMG");

        imgElements.forEach(
            (img) => {

                if (img.getAttribute("fixed") != "true") {
                    if ((img.style.maxWidth == null || img.style.maxWidth == "") && (img.style.width != null && img.style.width != "" && img.style.width != "100%")) {
                        img.style.maxWidth = img.style.width;
                        img.style.width = "100%";
                        img.style.height = "auto";
                    }
                }
            }
        );

    },


    PrepareImagesOrientation(containerElement) {
        let imgElements = new Array();
        let deviceWidth = 1;
        let imgElement, dataSrc;
        let i;


        if (containerElement == null) {
            containerElement = document.body;
        }

        if (document.querySelectorAll == null) {
            imgElements = document.getElementsByTagName("img");
        }
        else {
            imgElements = containerElement.querySelectorAll("IMG[src]");
        }


        for (i = 0; i < imgElements.length; i++) {
            dataSrc = imgElements[i].getAttribute("src") + "";
            imgElement = imgElements[i];

            if (imgElement.getAttribute("HasBindLoadEvent") == null) {

                if (imgElement.complete && imgElement.naturalHeight !== 0) {
                    //Image is Loaded
                    this.SetImageElementOrientation(imgElement);
                    imgElement.setAttribute("HasBindLoadEvent", "true");
                    continue;
                }
                else {

                    imgElement.addEventListener("load",
                        function (e) {

                            var imgElement = e.target;

                            this.SetImageElementOrientation(imgElement);

                            imgElement.setAttribute("HasBindLoadEvent", "true");

                        }.bind(this)
                    );
                }

            }
        }
    },


    ResetImagesOrientation(containerElement) {
        let imgElements = new Array();
        let deviceWidth = 1;
        let imgElement, dataSrc;
        let i;


        if (containerElement == null) {
            containerElement = document.body;
        }

        if (document.querySelectorAll == null) {
            imgElements = document.getElementsByTagName("img");
        }
        else {
            imgElements = containerElement.querySelectorAll("IMG[src]");
        }


        for (i = 0; i < imgElements.length; i++) {
            dataSrc = imgElements[i].getAttribute("src") + "";
            imgElement = imgElements[i];

            this.SetImageElementOrientation(imgElement);
        }
    },


    SetImageElementOrientation(imgElement) {
        let containerWidth = 100, containerHeight = 100;

        imgElement.setAttribute("LoadWidth", imgElement.width);
        imgElement.setAttribute("LoadHeight", imgElement.height);
        imgElement.setAttribute("LoadSrc", imgElement.src);


        if (imgElement.getAttribute("Fixed") == "true") {
            return;
        }

        try {
            if (
                imgElement.parentElement.classList.contains("PictureContainer")
            ) {
                if (imgElement.parentElement.clientWidth >= 40 &&
                    imgElement.parentElement.clientHeight >= 40
                ) {
                    containerWidth = imgElement.parentElement.clientWidth;
                    containerHeight = imgElement.parentElement.clientHeight;
                }
            }


            if ((imgElement.width / imgElement.height) > (containerWidth / containerHeight)) {
                if (imgElement.classList.contains("Portrait")) {
                    imgElement.classList.remove("Portrait");
                }
                if (!imgElement.classList.contains("Landscape")) {
                    imgElement.classList.add("Landscape");
                }
            }
            else {
                if (imgElement.classList.contains("Landscape")) {
                    imgElement.classList.remove("Landscape");
                }
                if (!imgElement.classList.contains("Portrait")) {
                    imgElement.classList.add("Portrait");
                }
            }
        }
        catch (ex) {
            alert(ex);
        }
    }
    ,

    StripHtml(html) {
        let tmp = document.createElement("DIV");

        tmp.innerHTML = html;

        return tmp.textContent || tmp.innerText || "";
    },


    OpenPictureMask(containerElement, picturePath) {
        let pictureItems = [];
        let imgElements;

        imgElements = containerElement.querySelectorAll("IMG");

        imgElements.forEach(
            (img) => {
                let pictureItem = {};

                pictureItem.PicturePath = img.getAttribute("src");
                pictureItem.Description = img.getAttribute("title");

                if (!pictureItems.some((pic) => (pic.PicturePath == pictureItem.PicturePath))) {
                    pictureItems.push(pictureItem);
                }

            }
        );


        if (window["vueComponent"] != null) {

            window["vueComponent"].$bus.$emit("OpenPictureMaskWindow", pictureItems, picturePath);
        }

    },


    ResetMenuItemClassByPath(path) {
        let allMenuItems;
        let currFullPath;
        let matchPathItems = [];
        let pathUrls = [];

        allMenuItems = document.body.querySelectorAll(".MenuItem");

        allMenuItems.forEach(
            (item) => {
                item.classList.remove("Path");
                item.classList.remove("Focus");
            }
        );

        currFullPath = path;

        allMenuItems.forEach(
            (item) => {
                let href;

                if (item.children.length > 0) {
                    href = item.children[0].getAttribute("href");

                    if (href != null && href != "") {
                        if (href == currFullPath) {
                            matchPathItems.push(item);
                        }
                    }
                }
            }
        );



        matchPathItems.forEach(
            (item) => {
                let parentElement = null;
                let url = "";



                item.classList.add("Path");
                item.classList.add("Focus");

                url = item.children[0].getAttribute("href");

                if (url != null && pathUrls.indexOf(url) < 0) {
                    pathUrls.push(url);
                }

                parentElement = item.parentElement;

                while (true) {

                    if (parentElement == null || parentElement.tagName == "BODY" || parentElement.classList.contains("Top")) {
                        break;
                    }

                    url = parentElement.children[0].getAttribute("href");

                    if (url != null && pathUrls.indexOf(url) < 0) {
                        pathUrls.push(url);
                    }

                    if (parentElement.classList.contains("MenuItem")) {
                        parentElement.classList.add("Path");
                    }

                    parentElement = parentElement.parentElement;
                }
            }
        );

        pathUrls.forEach(
            (url) => {
                let matchAnchorElements;
                let menuItemElement;

                matchAnchorElements = document.body.querySelectorAll(`.MenuItem > A[href='${url}']`);


                matchAnchorElements.forEach(
                    (anchorElement) => {
                        menuItemElement = anchorElement.parentElement;

                        if (!menuItemElement.classList.contains("Path")) {
                            menuItemElement.classList.add("Path");
                        }
                    }
                );
            }
        );

    },

    async MoveTo(element, offset) {
        let clientTop;
        let targetElement;

        await this.Delay(300);


        if (element != null && element.$el != null) {
            targetElement = element.$el;
        }
        else {
            targetElement = element;
        }

        clientTop = this.GetClientTop(targetElement);

        if (offset != null) {
            clientTop += offset;
        }

        window.scrollTo(0, clientTop);
    },


    DelayExecuteHandlerSet: {},


    DelayExecute(handler, handlerId, container, delayMillisecond) {
        let isFirst = false;
        let exists;
        let i;

        if (delayMillisecond == null) {
            delayMillisecond = 40;
        }

        if (container == null) {
            container = window;
        }

        if (handlerId == null) {
            handlerId = "DefaultHandlerId";
        }


        if (container.DelayExecuteHandlerSet == null) {
            container.DelayExecuteHandlerSet = {};
        }

        if (container.DelayExecuteHandlerSet[handlerId] == null) {
            isFirst = true;
        }
        else {
            isFirst = false;
        }

        container.DelayExecuteHandlerSet[handlerId] = handler;


        if (isFirst) {
            setTimeout(
                () => {
                    container.DelayExecuteHandlerSet[handlerId]();
                    delete container.DelayExecuteHandlerSet[handlerId];
                },
                delayMillisecond
            );
        }
    },

    Delay(millisecond) {
        let resolveHandler = null;
        let resultPromise = new Promise(
            (resolve) => {
                resolveHandler = resolve;
            }
        );

        if (millisecond == null) {
            throw "Utility.Delay() : millisecond is required !";
        }


        setTimeout(
            () => {
                resolveHandler();
            },
            millisecond
        );

        return resultPromise;
    },


    MoveToBottom() {

        setTimeout(
            function () {
                window.scrollTo(0, document.body.scrollHeight);
            }.bind(this),
            100
        );
    },


    TouchArray(array) {
        let dummy = {};

        array.push(dummy);

        this.RemoveArrayElement(array, dummy);
    },



    install(Vue, options) {

        Object.defineProperty(Vue.prototype,

            '$util', {
            get() {

                if (this.$_util == null) {
                    this.$_util = Utility;
                    this.$_util.Nav = new NavigationService(this);
                    this.$_util.vueComponent = this;



                }

                return this.$_util;
            }
        });
    },

    ConfirmApprove: function (title, description, confirmHandler) {
        let promiseResolveHandler = null;
        let vueComponent;
        let resultPromise = new Promise(
            (resolve) => {
                promiseResolveHandler = resolve;
            }
        );


        vueComponent = window["TopVue"];

        if (title == null) {
            title = "設定說明";
        }

        if (description == null) {
            description = "";
        }

        vueComponent.$modal.show("SettingConfirmDialog",
            {
                Title: title,
                Description: description,
                ConfirmHandler: function (content) {
                    if (confirmHandler != null) {
                        confirmHandler(content);
                    }
                    if (promiseResolveHandler != null) {
                        promiseResolveHandler(content);
                    }
                }.bind(this)
            }
        );


        return resultPromise;
    },



    CloneObject(obj) {
        let clonedObj;

        clonedObj = JSON.parse(
            JSON.stringify(obj)
        );

        return clonedObj;
    },

    CompareValueSet(valueSet1, valueSet2) {
        let equal = true;

        for (let propertyName in valueSet1) {
            if (valueSet1[propertyName] != valueSet2[propertyName]) {
                equal = false;
                break;
            }
        }

        if (equal) {
            for (let propertyName in valueSet2) {
                if (propertyName != "Version") {
                    if (valueSet1[propertyName] != valueSet2[propertyName]) {
                        equal = false;
                        break;
                    }
                }
            }
        }

        return equal;
    },

    CompareRows(originalRows, rows) {
        let equal = true;
        let i;

        if (originalRows.length != rows.length) {
            equal = false;
        }

        for (i = 0; i < originalRows.length; i++) {

            if (!this.CompareValueSet(originalRows[i].ValueSet, rows[i].ValueSet)) {
                equal = false;
                break;
            }
        }

        return equal;
    },

    ScrollToElement(element) {
        let clientTop;


        clientTop = this.GetClientTop(element);

        window.scrollTo(0, clientTop);
    },

    ScrollToTop() {
        let clientTop;


        window.scrollTo(0, 0);
    },



    ShowMessageDialog(component, message) {

        this.vueComponent = component;

        import("/src/Dialogs/MessageDialog").then(
            function (module) {
                let component;

                component = this.MountModule(module, "MessageDialog");

                component.Show(message);
            }.bind(this)
        );


    },

    MountModule: function (module, moduleName) {
        let TheVue;
        let divElement;
        let componentVue;
        let oldElements;
        let i;


        oldElements = document.querySelectorAll("#" + moduleName);

        for (i = 0; i < oldElements.length; i++) {
            oldElements[i].remove();
        }

        if (this.vueComponent.$el.querySelector("#" + moduleName) == null) {
            divElement = document.createElement("DIV");

            divElement.id = moduleName;
            this.vueComponent.$el.appendChild(divElement);
        }
        else {
            divElement = this.vueComponent.$el.querySelector("#" + moduleName);
        }

        if (this.vueComponent[moduleName + "ComponentVue"] != null) {
            this.vueComponent[moduleName + "ComponentVue"].$el.remove();
        }

        TheVue = window["VF"];

        componentVue = new TheVue(module.default);


        componentVue.router = this.$router;
        componentVue.$parent = this;
        componentVue.$bus = this.$bus;
        componentVue.$api = apiService;

        //componentVue.$mount("#" + moduleName);
        componentVue.$mount(divElement);

        this.vueComponent[moduleName + "ComponentVue"] = componentVue;

        componentVue = this.vueComponent[moduleName + "ComponentVue"]

        return componentVue;
    }, //end MountModule: function (module,moduleName) ,

    LoadModule(url) {
        let resultPromise = null;
        let postUrl = "";


        postUrl = url.replace("/Src", "");

        resultPromise = import("/Src" + postUrl);

        return resultPromise;
    },


    GetDialogCount() {
        let dialogCount = 0;

        dialogCount = window["TopVue"].DialogFrames.length;

        return dialogCount;
    },


    GetTopMostDialogFrame() {
        let topMostFrame;
        let topMostDialog = null;
        let length;

        length = window["TopVue"].DialogFrames.length;

        if (length > 0) {
            topMostFrame = window["TopVue"].DialogFrames[length - 1];

        }

        return topMostFrame;
    },


    CalcDialogHeight() {
        let dialogHeight;
        let componentContainerElements;
        let browserHeight;
        let scrollTop;
        let i;


        dialogHeight = document.body.clientHeight;

        browserHeight = Utility.GetBrowserHeight();

        if (browserHeight > dialogHeight) {
            dialogHeight = browserHeight;
        }

        scrollTop = Utility.GetScrollTop();

        componentContainerElements = document.body.querySelectorAll(".ComponentContainer");

        for (i = 0; i < componentContainerElements.length; i++) {
            if ((scrollTop + componentContainerElements[i].clientHeight) + 100 > dialogHeight) {

                dialogHeight = scrollTop + 20 + componentContainerElements[i].clientHeight + 100;
            }
        }


        return dialogHeight;
    },///end CalcDialogHeight() {


    NormalizeDialogUrl(url) {
        let absolutePath = "";
        let baseUrl;
        let linkElement;
        let href;


        absolutePath = url;

        if (url.length > 0) {
            if (url[0] == "@" || url[0] == "/") {
                //不須轉換
                absolutePath = url;
            }
            else {
                baseUrl = window.location.protocol + "//" + window.location.host;

                linkElement = document.createElement("A");
                linkElement.href = url;

                href = linkElement.href;

                absolutePath = href.replace(baseUrl, "");

                absolutePath = "/Src" + absolutePath;
            }
        }

        return absolutePath;
    },//end NormalizeDialogUrl(url) {


    ResizeMonitor: null,
    CheckResize: false,

    OnElementResize(e) {
        let i;

        for (i = 0; i < e.length; i++) {
            let element = e[i].target;

            if (element.classList.contains("ComponentContainer")) {
                if (!this.CheckResize) {
                    this.CheckResize = true;

                    setTimeout(
                        function () {
                            let topMostFrameElement;
                            let browserHeight;
                            let topMostFrame;
                            let componentContainerElement;
                            let dialogHeight;

                            topMostFrameElement = document.querySelector(".DialogFrame.TopMost");

                            dialogHeight = Utility.CalcDialogHeight();

                            if (topMostFrameElement != null) {

                                componentContainerElement = topMostFrameElement.querySelector(".ComponentContainer");


                                window["TopVue"].DialogHeight = dialogHeight;
                                window["TopVue"].$forceUpdate();

                                topMostFrame = Utility.GetTopMostDialogFrame();



                                if (componentContainerElement.clientHeight > 10) {
                                    if (topMostFrame != null) {
                                        browserHeight = Utility.GetBrowserHeight();


                                        if (browserHeight > componentContainerElement.clientHeight) {

                                            topMostFrame.DialogTop = Utility.GetScrollTop() +
                                                (
                                                    (browserHeight - componentContainerElement.clientHeight) / 2
                                                );
                                        }
                                        else if ((topMostFrame.DialogTop + componentContainerElement.clientHeight) > dialogHeight) {


                                            dialogHeight = topMostFrame.DialogTop + componentContainerElement.clientHeight + 100;
                                            window["TopVue"].DialogHeight = dialogHeight;
                                            window["TopVue"].$forceUpdate();
                                        }

                                        topMostFrame.DialogTop = topMostFrame.DialogTop - 150;
                                    }
                                }

                            }


                            this.CheckResize = false;
                        }.bind(this),
                        10
                    );
                }

            }
        }
        //console.log("OnElementResize e=" + e);
    },

    OpenDialog(url, args, frameArguments) {
        let normalizedUrl;
        let resolveHandler = null;
        let urlPrefix;
        let postUrl = "";
        let virtualDirectory = "";
        let resultPromise = new Promise(
            (resolve) => {
                resolveHandler = resolve;
            }
        );

        urlPrefix = this.GetUrlPrefix();

        if (this.ResizeMonitor == null && typeof (ResizeObserver) != "undefined") {

            this.ResizeMonitor = new ResizeObserver(
                this.OnElementResize
            );
        }



        normalizedUrl = this.NormalizeDialogUrl(url);


        if (url.indexOf("/Dialogs/") > 0) {
            postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Dialogs/", "");
            postUrl = (postUrl + "").replace("@/Dialogs/", "");


            import("/Src/Dialogs/" + postUrl).then(
                (module) => {
                    let frame = {};

                    if (args == null) {
                        args = {
                        };
                    }

                    frame.Component = module.default;
                    frame.Arguments = args;
                    frame.ElementDragger = new ElementDragger();
                    frame.DialogTop = Utility.GetScrollTop() + 20;
                    frame.CallBack = resolveHandler;
                    //module.default.props.Arguments = "value1";
                    module.default.Arguments = args;

                    window["TopVue"].DialogFrames.push(frame);

                    window["TopVue"].$forceUpdate();

                    //window["TopVue"].DialogHeight = document.body.clientHeight;

                    window["TopVue"].DialogHeight = this.CalcDialogHeight();

                    setTimeout(
                        () => {
                            let topMostFrameElement;
                            let toMoveElement;
                            let sourceElement;
                            let browserHeight;

                            topMostFrameElement = document.querySelector(".DialogFrame.TopMost");

                            window["TopVue"].DialogHeight = this.CalcDialogHeight();
                            window["TopVue"].$forceUpdate();

                            toMoveElement = topMostFrameElement.querySelector(".ComponentContainer");

                            sourceElement = toMoveElement.querySelector(":scope .DialogHeader");

                            browserHeight = Utility.GetBrowserHeight();

                            if (browserHeight > toMoveElement.clientHeight) {
                                frame.DialogTop = Utility.GetScrollTop() +
                                    (
                                        (browserHeight - toMoveElement.clientHeight) / 2
                                    );
                            }

                            if (toMoveElement != null && sourceElement != null) {
                                sourceElement.style.cursor = "move";
                                frame.ElementDragger.Attach(sourceElement, toMoveElement);
                            }

                            if (this.ResizeMonitor != null) {
                                this.ResizeMonitor.observe(toMoveElement);
                            }
                        },
                        10
                    );
                }
            ).catch(
                (ex) => {
                    alert(ex);
                }
            );
        }
        else {
            postUrl = (normalizedUrl + "").replace("/Src" + urlPrefix + "/Frontend/", "");
            postUrl = (postUrl + "").replace("@/Frontend/", "");

            import("/Src/Frontend/" + postUrl).then(
                (module) => {
                    let frame = {};

                    if (args == null) {
                        args = {
                        };
                    }

                    frame.Component = module.default;
                    frame.Arguments = args;
                    frame.ElementDragger = new ElementDragger();
                    frame.DialogTop = Utility.GetScrollTop() + 20;
                    frame.CallBack = resolveHandler;
                    //module.default.props.Arguments = "value1";
                    module.default.Arguments = args;

                    window["TopVue"].DialogFrames.push(frame);

                    window["TopVue"].$forceUpdate();

                    //window["TopVue"].DialogHeight = document.body.clientHeight;

                    window["TopVue"].DialogHeight = this.CalcDialogHeight();

                    setTimeout(
                        () => {
                            let topMostFrameElement;
                            let toMoveElement;
                            let sourceElement;
                            let browserHeight;

                            topMostFrameElement = document.querySelector(".DialogFrame.TopMost");

                            window["TopVue"].DialogHeight = this.CalcDialogHeight();
                            window["TopVue"].$forceUpdate();

                            toMoveElement = topMostFrameElement.querySelector(".ComponentContainer");
                            sourceElement = toMoveElement.querySelector(".DialogHeader");

                            browserHeight = Utility.GetBrowserHeight();

                            if (browserHeight > toMoveElement.clientHeight) {
                                frame.DialogTop = Utility.GetScrollTop() +
                                    (
                                        (browserHeight - toMoveElement.clientHeight) / 2
                                    );
                            }

                            if (toMoveElement != null && sourceElement != null) {
                                sourceElement.style.cursor = "move";
                                frame.ElementDragger.Attach(sourceElement, toMoveElement);
                            }



                            if (this.ResizeMonitor != null) {
                                this.ResizeMonitor.observe(toMoveElement);
                            }
                        },
                        10
                    );
                }
            ).catch(
                (ex) => {
                    alert(ex);
                }
            );
        }


        return resultPromise;
    }, //end OpenDialog(url, args) {



    PrefixUrl(url) {
        let prefix;

        prefix = this.GetUrlPrefix();

        if (url.indexOf(prefix) < 0) {
            if (url != null && url[0] == '/') {
                url = prefix + url;
            }
        }

        return url;
    },

    GetUrlPrefix() {
        let prefix = "";
        let virtualDirectory;

        virtualDirectory = Utility.GetVirtualDirectory();

        if (virtualDirectory != "") {
            prefix = "/" + virtualDirectory;
        }

        return prefix;
    },


    GetVirtualDirectory() {
        let virtualDirectory = "";;

        if (typeof (AppSettings) != "undefined" && typeof (AppSettings) == "object") {

            if (AppSettings.VirtualDirectory != null && AppSettings.VirtualDirectory != "") {
                virtualDirectory = AppSettings.VirtualDirectory;
            }
            else {
                virtualDirectory = "";
            }
        }

        return virtualDirectory;
    },



    CloseDialog(result) {
        let topMostFrame;
        let length;


        length = window["TopVue"].DialogFrames.length;

        if (length > 0) {
            topMostFrame = this.GetTopMostDialogFrame();

            topMostFrame.CallBack(result);



            window["TopVue"].DialogFrames.splice(length - 1, 1);

            topMostFrame.ElementDragger.Detach();
        }
    },//end CloseDialog(result) {


    PrepareData(vueComponent) {
        let dataJson1, version1, updateStaffId1, updateTime1;




        dataJson1 = JSON.stringify(vueComponent.$data);

        if (vueComponent.$data.ValueSet != null) {
            version1 = vueComponent.$data.ValueSet.Version;
            updateStaffId1 = vueComponent.$data.ValueSet.UpdateStaffId;
            updateTime1 = vueComponent.$data.ValueSet.UpdateTime;

            if (updateStaffId1 == null) {
                updateStaffId1 = Utility.GetBag("StaffId");
            }
            if (updateTime1 == null) {
                updateTime1 = new Date();
            }
        }
        else {
            version1 = vueComponent.$data.Version;
            updateStaffId1 = vueComponent.$data.UpdateStaffId;
            updateTime1 = vueComponent.$data.UpdateTime;

            if (updateStaffId1 == null) {
                updateStaffId1 = Utility.GetBag("StaffId");
            }
            if (updateTime1 == null) {
                updateTime1 = new Date();
            }
        }




        vueComponent.DataJson1 = dataJson1;
        vueComponent.Version1 = version1;
        vueComponent.UpdateStaffId1 = updateStaffId1;
        vueComponent.UpdateTime1 = updateTime1;




        if (vueComponent.Version1 == null) {
            //alert("Utility.PrepareData() : vueComponent.Version1 == null");
            //throw "Utility.PrepareData() : vueComponent.Version1 == null";
        }
    },




    BackupData(vueComponent, responseData, ignorePropertyNames) {
        let rh = null;
        let resultPromise = new Promise(r => rh = r);
        let dataJson2, version2, updateStaffId2, updateTime2;
        let dataJson;
        let staffId;
        let updateTime;
        let dataObject1, dataObject2;
        let equal;
        let _ignorePropertyNames = ["FinalMode", "Version", "UpdateTime", "OriginalValueSet", "SecondRows", "Status", "JobSteps"]


        if (ignorePropertyNames != null) {
            _ignorePropertyNames.push(...ignorePropertyNames);
        }

        if (
            responseData.ValueSet != null &&
            responseData.ValueSet.JobNo != null
        ) {
            if (vueComponent.Version1 == null) {
                console.log("Utility.BackupData() : vueComponent.Version1 is null !");
                //return;
            }

            dataJson2 = JSON.stringify(vueComponent.$data);

            if (responseData != null && responseData.ValueSet.Version != null) {
                version2 = responseData.ValueSet.Version;
            }
            else {
                version2 = vueComponent.$data.ValueSet.Version;
            }

            updateStaffId2 = this.GetBag("StaffId");
            updateTime2 = new Date();

            if (vueComponent.DataJson1 != null && dataJson2 != null) {
                dataObject1 = JSON.parse(vueComponent.DataJson1);
                dataObject2 = JSON.parse(dataJson2);

                if (vueComponent.Version1 != null && vueComponent.DataJson1 != null) {
                    equal = this.CompareObjects(
                        dataObject1, dataObject2,
                        //Ignoare Properties
                        _ignorePropertyNames
                    );


                    if (equal) {//資料似乎沒有修改
                        dataJson2 = null; //將 Version2 的資訊清空 , 後端不會新增此 Version
                        version2 = null;
                        updateStaffId2 = null;
                        updateTime2 = null;
                    }
                }
            }

            apiService.Post("/api/JobStep/BackupJobData",
                {
                    ValueSet: {
                        JobNo: responseData.ValueSet.JobNo,

                        Data1: vueComponent.DataJson1,
                        Version1: vueComponent.Version1,
                        UpdateStaffId1: vueComponent.UpdateStaffId1,
                        UpdateTime1: vueComponent.UpdateTime1,

                        Data2: dataJson2,
                        Version2: version2,
                        UpdateStaffId2: updateStaffId2,
                        UpdateTime2: updateTime2,
                    }
                }
            ).then(
                function (result) {
                    rh("BackupData Completed !");
                }
            );
        }
        else if (
            responseData.JobNo != null
        ) {


            if (vueComponent.Version1 == null) {
                //alert("Utility.BackupData() : vueComponent.Version1 is null !");
                //return;
            }

            dataJson2 = JSON.stringify(vueComponent.$data);

            if (responseData != null && responseData.Version != null) {
                version2 = responseData.Version;
            }
            else {
                version2 = vueComponent.$data.Version;
            }

            updateStaffId2 = this.GetBag("StaffId");
            updateTime2 = new Date();


            apiService.Post("/api/JobStep/BackupJobData",
                {
                    ValueSet: {
                        JobNo: responseData.JobNo,

                        Data1: vueComponent.DataJson1,
                        Version1: vueComponent.Version1,
                        UpdateStaffId1: vueComponent.UpdateStaffId1,
                        UpdateTime1: vueComponent.UpdateTime1,


                        Data2: dataJson2,
                        Version2: version2,
                        UpdateStaffId2: updateStaffId2,
                        UpdateTime2: updateTime2,
                    }
                }
            ).then(
                function (result) {
                    rh("BackupData Completed !");
                }
            );
        }
        else if (vueComponent.Action == "CreateVersion") {
            let jobNo, version, dataJson, updateStaffId, updateTime;

            if (vueComponent.$parent.$data.ValueSet != null) {
                jobNo = vueComponent.$parent.$data.ValueSet.JobNo;
                version = vueComponent.$parent.$data.ValueSet.Version;
            }
            else {
                jobNo = vueComponent.$parent.$data.JobNo;
                version = vueComponent.$parent.$data.Version;
            }

            dataJson = JSON.stringify(vueComponent.$data);

            if (responseData.Version != null) {
                version = responseData.Version;
            }
            else if (responseData.ValueSet != null && responseData.ValueSet.Version != null) {
                version = responseData.ValueSet.Version;
            }
            else if (vueComponent.$data.Version != null) {
                version = vueComponent.$data.Version;
            }
            else if (vueComponent.$data.ValueSet != null && vueComponent.$data.ValueSet.Version != null) {
                version = vueComponent.$data.ValueSet.Version;
            }
            else {
                alert("Utility.BackupData() : Action=CreatVersion , 但無法判斷 Version !");
                throw "Utility.BackupData() : Action=CreatVersion , 但無法判斷 Version !";
            }

            updateStaffId = this.GetBag("StaffId");
            updateTime = new Date();


            apiService.Post("/api/JobStep/BackupJobData",
                {
                    ValueSet: {
                        JobNo: jobNo,
                        Version: version,
                        Data: dataJson,
                        Version: version,
                        UpdateStaffId: updateStaffId,
                        UpdateTime: updateTime,
                    }
                }
            ).then(
                function (result) {

                    rh("BackupData Completed !");
                }
            );

        }

        return resultPromise;

    },//end BackupData(vueComponent, responseData) {



    CompareObjects(dataObject1, dataObject2, ignorePropertyNames) {
        let equal = true;
        let propertyName;
        let count = 0;
        let i;



        for (propertyName in dataObject1) {



            if (ignorePropertyNames != null &&
                ignorePropertyNames.indexOf(propertyName) >= 0
            ) {
                continue;
            }

            if (dataObject2.hasOwnProperty(propertyName)) {

                if (Utility.IsDateObject(dataObject1[propertyName])) {
                    if (this.GetDateText(dataObject1[propertyName]) == dataObject2[propertyName]) {
                        count++;
                    }
                    else {
                        //if (this.DiffPropertyNames.indexOf(propertyName) < 0) {
                        //    this.DiffPropertyNames.push(propertyName);
                        //}

                        break;
                    }
                }
                else if (Array.isArray(dataObject1[propertyName])) {

                    if (Array.isArray(dataObject2[propertyName])) {

                        if (dataObject1[propertyName].length == dataObject2[propertyName].length) {

                            for (i = 0; i < dataObject1[propertyName].length; i++) {

                                if (
                                    Utility.IsDateObject(dataObject1[propertyName][i]) &&
                                    Utility.IsDateObject(dataObject2[propertyName][i])
                                ) {
                                    equal = (
                                        Utility.GetDateTimeText(dataObject1[propertyName][i]) ==
                                        Utility.GetDateTimeText(dataObject2[propertyName][i])
                                    );
                                } else if (typeof dataObject1[propertyName][i] == "object" &&
                                    typeof dataObject2[propertyName][i] == "object"
                                ) {
                                    equal = this.CompareObjects(
                                        dataObject1[propertyName][i],
                                        dataObject2[propertyName][i],
                                        ignorePropertyNames
                                    );
                                }
                                else {
                                    equal = (dataObject1[propertyName][i] ==
                                        dataObject2[propertyName][i]);
                                }

                                if (!equal) {
                                    //if (this.DiffPropertyNames.indexOf(propertyName) < 0) {
                                    //    this.DiffPropertyNames.push(propertyName);
                                    //}

                                    break;
                                }
                            }
                        }
                        else {
                            equal = false;
                        }
                    }
                    else {
                        equal = false;
                    }
                }
                else if (
                    typeof dataObject1[propertyName] == "object" &&
                    typeof dataObject2[propertyName] == "object"
                ) {
                    equal = this.CompareObjects(dataObject1[propertyName], dataObject2[propertyName], ignorePropertyNames);
                }
                else if (dataObject1[propertyName] == dataObject2[propertyName]) {
                    count++;
                }
                else {
                    equal = false;
                }
            }
            else {
                equal = false;
            }

            if (!equal) {


                //if (this.DiffPropertyNames.indexOf(propertyName) < 0) {
                //    this.DiffPropertyNames.push(propertyName);
                //}

                break;
            }
        }

        return equal;
    },


    AddDays(dateObject, toAddDayCount) {
        let newDateObject;

        newDateObject = new Date(dateObject);

        newDateObject.setDate(newDateObject.getDate() + toAddDayCount);

        return newDateObject;
    },


    AddMonths(dateObject, toAddMonthCount) {
        let newDateObject;

        newDateObject = new Date(dateObject.setMonth(dateObject.getMonth() + toAddMonthCount));


        return newDateObject;
    },

    RemoveDatePart(dateObject) {
        let newDateObject;

        newDateObject = new Date(this.GetDateText(dateObject));

        return newDateObject;
    },


    //#region 浮水印
    /// 浮水印使用的日期時間，民國年，無分隔符號
    WaterMarkDate() {
        const newDate = new Date();
        const yy = newDate.getFullYear() - 1911;
        const month = (newDate.getMonth() + 1).toString().padStart(2, "0");
        const day = newDate.getDate().toString().padStart(2, "0");
        const hour = newDate.getHours().toString().padStart(2, "0");
        const min = newDate.getMinutes().toString().padStart(2, "0");
        const sec = newDate.getSeconds().toString().padStart(2, "0");
        const dateStr = `${yy}${month}${day} ${hour}:${min}:${sec}`;
        return dateStr;
    },

    /// 浮水印使用的使用者IP
    WaterMarkUserIp() {
        const promise = new Promise(function (resolve, reject) {
            apiService.Post("/api/SuspiciousTranContext/UserIp", {}).then(
                function (result) {
                    resolve(result);
                    //return result.toString();
                }
            ).catch((error) => {
                console.log(error);
            });
        }).then(value => { return value; });

        return promise;
    },

    /// 浮水印所需字串，目前為加浮水印用日期時間，使用者IP、使用者id
    WaterMarkString() {
        const promise = new Promise(function (resolve, reject) {
            const userIp = Utility.WaterMarkUserIp();
            resolve(userIp);
        }).then(userIp => {
            const dateStr = Utility.WaterMarkDate();
            const StaffId = Utility.GetBag("StaffId");

            const waterMarkStr = `${dateStr} ${userIp} ${StaffId}`;
            return waterMarkStr;
        });

        return promise;
    },
    //#endregion


}//end var Utility = {



Utility.TopVueComponent = null;

Utility.CheckBags();

//每十秒更新一次 BagUpdateTime
setInterval(
    function () {
        Utility.ModifyBagUpdateTime();
    },
    1000 * 5
);


setTimeout(
    function () {
        Utility.ModifyLongBagUpdateTime();
    },
    1000
);



let WindowLayout = function () {
    this.X = 0;
    this.Y = 0;
    this.Width = 0;
    this.Height = 0;
}


setTimeout(
    () => {

        if (Utility.Nav == null) {
            Utility.Nav = new NavigationService(window["TopVue"]);
        }
    },
    10
);


export default Utility;

